import api from "./Api";

class ModelosVendasCupomService {
  GetModelosVendasCupom(payload) {
    return api.get("/v1/modelosVendasCupom/" + payload).then((response) => {
      return response.data;
    });
  }

  PostModelosVendasCupom(payload) {
    return api.post("/v1/modelosVendasCupom/", payload).then((response) => {
      return response.data;
    });
  }

  PutModelosVendasCupom(payload) {
    return api.put("/v1/modelosVendasCupom/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteModelosVendasCupom(payload) {
    return api.delete("/v1/modelosVendasCupom/" + payload).then((response) => {
      return response.data;
    });
  }

  GetModelosVendasCupomOData(payload) {
    return api.get("/OData/ModelosVendasCupom" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ModelosVendasCupomService();
